'use es6';

import { Component, PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'underscore';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import ComponentMap from 'FormsUI/constants/FieldConfigurationComponentMap';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { update as updateFromAction } from 'FormsUI/actions/Field';
import { getSelectedField, canBeMadeRequired as canBeMadeRequiredSelector, canBeMadeHidden as canBeMadeHiddenSelector } from 'FormsUI/selectors/Field';
import HTMLEscape from 'forms-utils-lib/utils/HTMLEscape';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import { CommentableArea } from 'collaboration-sidebar';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Small } from 'foundations-components/transitional/components/Small';
import RichTextEditor from 'FormsUI/loadable/AsyncRichTextEditor';
import getConfigurationType from 'forms-utils-lib/formField/utils/getConfigurationType';
import createFormField from 'forms-utils-lib/formField/utils/createFormField';
import updateFormFieldKey from 'forms-utils-lib/formField/utils/updateFormFieldKey';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import { MAKE_REQUIRED_PANEL, MAKE_HIDDEN_PANEL, EDITED_LABEL, EDITED_PLACEHOLDER, EDITED_HELP_TEXT } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import debounce from 'hs-lodash/debounce';
import { Flex } from 'foundations-components/components/Flex';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { Spacer } from 'foundations-components/components/Spacer';
import { View } from 'foundations-components/transitional/components/View';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const langKey = suffix => `editor.form.config.${suffix}`;
const helpTooltipMessage = fieldType => fieldType === FieldTypes.SINGLE_CHECKBOX ? langKey('helpTextToolTipAbove') : langKey('helpTextToolTipBelow');
export const LabelField = ({
  label,
  handleUpdate
}) => /*#__PURE__*/_jsx(RichTextEditor, {
  content: label,
  onChange: value => {
    debounce(() => trackEditorInteraction(EDITED_LABEL), 1000)();
    handleUpdate(FormFieldKeys.LABEL, value);
  },
  config: "LABEL",
  isSingleLine: true,
  "data-editable-field": "label"
});
class Default extends PureComponent {
  render() {
    const {
      field,
      update
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.props.RequiredField, this.props.HiddenField, this.props.LabelField, /*#__PURE__*/_jsx(Spacer, {}), this.props.HelpTextField, /*#__PURE__*/_jsx(Spacer, {}), this.props.renderPlaceholderField({
        update: newValue => update(updateFormFieldKey(field, FormFieldKeys.PLACEHOLDER, newValue)),
        value: field.placeholder,
        field
      }), /*#__PURE__*/_jsx(Spacer, {})]
    });
  }
}
function retriveComponentForType(type) {
  return ComponentMap[type] || Default;
}
class Base extends Component {
  constructor() {
    super();
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  /* Prevents jump in sliding animation on panel */
  shouldComponentUpdate({
    field
  }) {
    return !isEmpty(field);
  }
  handleUpdate(key, value) {
    const {
      field,
      update
    } = this.props;
    if (isEmpty(field)) {
      return;
    }
    update(updateFormFieldKey(field, key, value));
  }

  /* Used as render prop */
  renderPlaceholderField({
    update,
    value,
    disabled,
    disabledMessage,
    field
  }) {
    return /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: `${getPropertyObjectTypeId(field)}-placeholder`,
      description: {
        translationKey: 'formsPlaceholder'
      },
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('placeholderText')
          }),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('placeholderTextToolTip')
          }),
          tooltipPlacement: "top right",
          children: /*#__PURE__*/_jsx(TextInput, {
            disabled: disabled,
            defaultValue: sanitize(value, config.TEXTONLY),
            use: "on-dark",
            "data-test-id": "config-field-placeholder",
            onChange: ({
              target
            }) => {
              debounce(() => trackEditorInteraction(EDITED_PLACEHOLDER), 1000)();
              update(HTMLEscape(target.value));
            },
            "data-editable-field": "placeholder"
          })
        }), disabled ? /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: disabledMessage
        }) : null]
      })
    });
  }
  renderLabel() {
    const {
      field
    } = this.props;
    return /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: `${getPropertyObjectTypeId(field)}-label`,
      description: {
        translationKey: 'formsLabel'
      },
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "config-field-label",
        children: /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('label')
          }),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('labelToolTip')
          }),
          tooltipPlacement: "top right",
          children: /*#__PURE__*/_jsx(LabelField, {
            label: field.label,
            handleUpdate: this.handleUpdate
          })
        })
      })
    });
  }
  renderHelpText() {
    const {
      field
    } = this.props;
    return /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: `${getPropertyObjectTypeId(field)}-help-text`,
      description: {
        translationKey: 'formsHelpText'
      },
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "config-field-help-text",
        children: /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('helpText')
          }),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: helpTooltipMessage(field.fieldType)
          }),
          tooltipPlacement: "top right",
          children: /*#__PURE__*/_jsx(RichTextEditor, {
            content: field.description,
            onChange: value => {
              debounce(() => trackEditorInteraction(EDITED_HELP_TEXT), 1000)();
              this.handleUpdate(FormFieldKeys.DESCRIPTION, value);
            },
            config: "LABEL",
            isSingleLine: true,
            "data-editable-field": "description"
          })
        })
      })
    });
  }
  renderRequired() {
    const {
      field,
      update,
      canBeMadeRequired
    } = this.props;
    return /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: `${getPropertyObjectTypeId(field)}-required-field`,
      description: {
        translationKey: 'formsRequiredField'
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "row",
        gap: "200",
        marginBlockEnd: "400",
        children: [/*#__PURE__*/_jsx(Toggle, {
          checked: field.required,
          disabled: !canBeMadeRequired,
          onChange: () => {
            trackEditorInteraction(MAKE_REQUIRED_PANEL, {
              value: [field.required ? 'made-not-required' : 'made-required']
            });
            update(updateFormFieldKey(field, FormFieldKeys.REQUIRED, !field.required));
          },
          size: "small",
          "data-editable-field": "required",
          "data-test-id": "required-field-toggle",
          id: "required-field-toggle"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('requiredField')
        })]
      })
    });
  }
  renderHidden() {
    const {
      field,
      update,
      canBeMadeHidden
    } = this.props;
    return /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: `${getPropertyObjectTypeId(field)}-hidden-field`,
      description: {
        translationKey: 'formsHiddenField'
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('hiddenFieldDisabled')
          }),
          disabled: canBeMadeHidden,
          placement: "right",
          children: /*#__PURE__*/_jsx(Toggle, {
            checked: field.hidden,
            disabled: !canBeMadeHidden,
            id: "hidden-field",
            onChange: () => {
              trackEditorInteraction(MAKE_HIDDEN_PANEL, {
                value: [field.hidden ? 'made-not-hidden' : 'made-hidden']
              });
              update(updateFormFieldKey(field, FormFieldKeys.HIDDEN, !field.hidden));
            },
            size: "small",
            "data-editable-field": "hidden",
            "data-test-id": "hidden-field-toggle"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: langKey('hiddenField')
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('hiddenToggleTooltip')
          }),
          placement: "right",
          children: /*#__PURE__*/_jsx(View, {
            as: "span",
            children: /*#__PURE__*/_jsx(InfoIcon, {
              size: "200"
            })
          })
        })]
      })
    });
  }
  render() {
    const {
      field,
      update
    } = this.props;
    const fieldConfig = getConfigurationType(field);
    const ConfigurationComponent = retriveComponentForType(fieldConfig);
    return /*#__PURE__*/_jsx(ConfigurationComponent, {
      LabelField: this.renderLabel(),
      HelpTextField: this.renderHelpText(),
      RequiredField: this.renderRequired(),
      HiddenField: this.renderHidden(),
      renderPlaceholderField: this.renderPlaceholderField,
      field: field,
      update: update
    });
  }
}
Base.defaultProps = {
  field: createFormField({})
};
const mapStateToProps = state => ({
  field: getSelectedField(state),
  canBeMadeRequired: canBeMadeRequiredSelector(state),
  canBeMadeHidden: canBeMadeHiddenSelector(state)
});
const actionCreators = {
  update: updateFromAction
};
export default connect(mapStateToProps, actionCreators)(Base);